import { IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { ConnectionType } from '../store/schema/ConnectionType';

export function getAuthenticationOptions(connectionType: ConnectionType): IDropdownOption[] {
    if (connectionType === ConnectionType.ImapSmtp) {
        return [
            {
                key: 'Basic',
                text: 'Basic',
            },
            {
                key: 'Ntlm',
                text: 'NTLM',
            },
        ];
    } else if (connectionType === ConnectionType.PopSmtp) {
        return [
            {
                key: 'Basic',
                text: 'Basic',
            },
            {
                key: 'Spa',
                text: 'SPA',
            },
        ];
    }

    return [];
}
